import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Filters from './components/inputs/'
import Tables from './components/tables';
import TablesStock from './components/tablesStock';
import ChartsLiner from './components/charts/index';
import CountRecord from './components/countRecord';
import { data_m } from "../../../method/date";



let useStyles = makeStyles((theme) => ({
    root: {
        padding: '20px',
        position: 'relative',
        [theme.breakpoints.down("700")]: {
            position: 'relative',
            width: '100%',
            padding: '20px',
        },
        [theme.breakpoints.down("500")]: {
            padding: '5px',
        },
    },
    grid: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '90%',
        minWidth: 1447,
        margin: 'auto',
        marginTop: 20,
        [theme.breakpoints.down("1550")]: {
            width: '100%',
            minWidth: '99%',
        },
        [theme.breakpoints.down("1100")]: {
            flexDirection: 'column'
        },
    }
}))


export default function Index() {

    let classes = useStyles();

    const [stock, setStock] = useState({});

    const [state, setState] = useState({
        currency_id: 1,
        commodity_id: null,
        main_category: null,
        category: null,
        sub_category: null,
        date_from: null,
        date_to: null,
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [flegApi, setFlagApi] = useState(false);




    return (
        <>
            <div className={classes['root']}>
                <Filters
                    state={state}
                    setState={setState}
                    setFlagApi={setFlagApi}
                />
                <CountRecord />
                <Tables
                    page={page}
                    state={state}
                    flegApi={flegApi}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    stock={stock}
                    setStock={setStock}
                />
                <div className={classes['grid']}>
                    <TablesStock
                        data={state}
                        stock={stock}
                        setStock={setStock}
                    />
                    <ChartsLiner />
                </div>
            </div>
        </>

    )
}
